const contactcontent = {
  blurb:
    "Have questions about our services, want to learn more about our approach to physical therapy, or have inquiries about the doc? We're here to help! Fill out the form with your details and any questions you may have. Whether it's about scheduling, specific treatments, or anything else related to your health and wellness, your well-being is our priority and we look forward to connecting with you!",
};

export default contactcontent;
